import styled, { useTheme, css } from "styled-components";
import Button from './button'

const StyledButton = styled(Button)`
  ${props => props.disabled && css`
    border: 1px solid #0F204133;
    color: #0F204133;
  `}
  ${props => !props.disabled && css`
    border: 1px solid ${props.theme.mainColor};
  `}
`;

function SelectionRow({
  label,
  subLabel,
  value,
  onAdd,
  onSubtract,
  min,
  max,
  srValue,
}) {
  const theme = useTheme();
  return (
    <div className="ul-flex ul-justify-between ul-py-10">
      <div className="ul-flex ul-flex-col ul-justify-center">
        <div
          className="ul-font-medium ul-text-17"
          id={`selection-row-label-${label}`}
        >
          {label}
        </div>
        <div className="ul-text-14 ul-opacity-60 ul-mt-2">{subLabel}</div>
      </div>
      <div className="ul-flex ul-items-center">
        <StyledButton
          theme={theme}
          outline
          className="ul-h-40 ul-w-40"
          disabled={value <= min}
          onClick={onSubtract}
          aria-label="Subtract 1"
          aria-describedby={`selection-row-label-${label}`}
        >
          <span className="ul-text-22 ul-font-semibold">-</span>
        </StyledButton>
        <span className="ul-font-medium ul-px-5 ul-w-35 ul-text-center" aria-hidden>
          {value}
        </span>
        <span className="ul-sr-only" aria-live="polite">
          {srValue}
        </span>
        <StyledButton
          theme={theme}
          outline
          className="ul-h-40 ul-w-40"
          disabled={value >= max}
          onClick={onAdd}
          aria-label="Add 1"
          aria-describedby={`selection-row-label-${label}`}
        >
          <span className="ul-text-22 ul-font-semibold">+</span>
        </StyledButton>
      </div>
    </div>
  )
}

export default SelectionRow
